import { Component, Output, EventEmitter } from "@angular/core";

declare let QRCode: any;

@Component({
    selector: "qr-code-modal",
    template: `
        <div class="mod mod-modal" [class.is-open]="isVisible">
            <div class="mod-modal__dialog mod-modal__dialog--small">
                <div class="mod-modal__content">
                    <div
                        class="zas-esign-row"
                        style="background: white; height: 20px; color: black;"
                    >
                        <p class="leader">
                            Beratungsdokumentation auf anderem Gerät anzeigen.
                        </p>
                        <div class="qrcode-box">
                            <p>
                                Scannen Sie diesen QR-Code mit Ihrem Tablet, um
                                die Beratungsdokumentation auf dem Tablet zu
                                unterschreiben. Klicken Sie erst auf
                                "Schließen", nachdem Sie die Bearbeitung auf dem
                                Tablet abgeschlossen haben.
                            </p>
                            <div id="qrcode"></div>
                            <p>
                                <a [href]="target">{{ target }}</a>
                            </p>
                        </div>
                    </div>
                </div>
                <div class="mod-modal__footer">
                    <button class="zas-button" (click)="close()">
                        Schließen
                    </button>
                </div>
            </div>
        </div>
    `,
    styleUrls: ["./zurich-style.css", "./zurich.css", "./main.css"],
    styles: [
        `
            .leader {
                font-weight: bold;
            }
            #qrcode {
                margin: 0 auto;
            }
            a {
                width: 100%;
                text-align: center;
            }
        `,
    ],
})
export class QRCodeModal {
    @Output() onClose = new EventEmitter<void>();

    isVisible = false;

    target: string;
    private qrcode;

    public createQRCode() {
        const container = document.getElementById("qrcode");
        while (container.firstChild) {
            container.removeChild(container.firstChild);
        }
        this.target = window.location.href.replace(/\?.*/, "") + "/esign/";
        const qrcode = new QRCode(container, {
            text: this.target,
            width: 340,
            height: 340,
            colorDark: "#000000",
            colorLight: "#ffffff",
            correctLevel: QRCode.CorrectLevel.H,
        });
    }

    public open(): void {
        this.createQRCode();
        this.isVisible = true;
    }

    public close(): void {
        if (this.isVisible) {
            this.isVisible = false;
            this.onClose.emit();
        }
    }
}
